import { render, staticRenderFns } from "./NewStevedore.vue?vue&type=template&id=7a87708f&"
import script from "./NewStevedore.vue?vue&type=script&lang=js&"
export * from "./NewStevedore.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports